import { Plus, Trash2 } from 'lucide-react';
import { PersonFields } from './PersonFields';

export function ParentProfileForm({ kids, onUpdate, onAdd, onRemove }) {
  return (
    <div className="px-5 py-6 sm:px-8 sm:py-7">
      <div className="space-y-4">
        {kids.map((kid, index) => (
          <div
            key={kid.id}
            className="rounded-2xl border-2 border-slate-200 bg-white p-5 shadow-sm sm:p-6"
          >
            <div className="mb-4 flex items-center justify-between">
              <h3 className="text-base font-bold text-slate-900">
                Kid {index + 1}
              </h3>
              {kids.length > 1 && (
                <button
                  type="button"
                  onClick={() => onRemove(kid.id)}
                  aria-label={`Remove Kid ${index + 1}`}
                  className="inline-flex cursor-pointer items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold text-rose-600 transition-colors hover:bg-rose-50"
                >
                  <Trash2 className="size-3.5" aria-hidden="true" />
                  Remove
                </button>
              )}
            </div>
            <PersonFields
              data={kid}
              onChange={(next) => onUpdate(kid.id, next)}
              idPrefix={`kid-${kid.id}`}
            />
          </div>
        ))}
        <button
          type="button"
          onClick={onAdd}
          className="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-brand-300 bg-white px-4 py-3 text-sm font-semibold text-brand-700 transition-colors hover:border-brand-500 hover:bg-brand-50"
        >
          <Plus className="size-4" aria-hidden="true" />
          Add another kid
        </button>
      </div>
    </div>
  );
}